import { DisplayElementModel } from './display-element.model';
import { Type } from '@angular/core';
import { FormFieldModel } from './form-field.model';

export class BlockTypeModel {
    key: string;
    label: string;
    icon: string;
    twig: string;
    displayElementType: Type<DisplayElementModel>;
    fields: FormFieldModel[];
    componentType?: Type<any>;

    // Statuses for the block adder
    canAdd: boolean = true;
    remainingCount?: number;
    isDashboard?: boolean;
    showInBlockAdder: boolean = true;
    reachLimitMessage: string = 'Briefing.blocks.reachLimit.general';
    isLocked: boolean = false;
    allowInsideLayout?: boolean = true;
    allowInsideCurator?: boolean = true;

    constructor(
        key: string,
        label: string,
        icon: string,
        twig: string,
        displayElementType: Type<DisplayElementModel>,
        fields: FormFieldModel[],
        componentType?: Type<any>,
        isDashboard?: boolean,
        reachLimitMessage?: string,
        allowInsideLayout: boolean = true,
        allowInsideCurator: boolean = true,
    ) {
        this.key = key;
        this.label = label;
        this.icon = icon;
        this.twig = twig;
        this.displayElementType = displayElementType;
        this.fields = fields;
        this.componentType = componentType;
        this.isDashboard = isDashboard;
        if (reachLimitMessage) {
            this.reachLimitMessage = reachLimitMessage;
        }
        this.allowInsideLayout = allowInsideLayout;
        this.allowInsideCurator = allowInsideCurator;
    }

    public clone(): BlockTypeModel {
        const clone = new BlockTypeModel(
            this.key,
            this.label,
            this.icon,
            this.twig,
            this.displayElementType,
            this.fields.slice(),
            this.componentType,
            this.isDashboard,
            this.reachLimitMessage,
            this.allowInsideLayout,
            this.allowInsideCurator
        );

        return clone;
    }

    public cloneFields(key: string, label: string, icon: string): BlockTypeModel {
        const clone = this.clone();
        clone.key = key;
        clone.label = label;
        clone.icon = icon;

        return clone;
    }
}
